import { listSteps } from 'utils/LayoutUtils';
import {
  DECREASE_STEP,
  INCREASE_STEP,
  SET_STEP,
} from './StepActions';

export const stepReducer = (state = 0, action) => {
  const { type, jumpStep } = action;
  switch (type) {
  case INCREASE_STEP: {
    if (state + 1 >= listSteps.length) {
      return state;
    }
    return state + 1;
  }

  case DECREASE_STEP: {
    if (state - 1 < 0) {
      return state;
    }
    return state - 1;
  }
  case SET_STEP: {
    return jumpStep;
  }
  default: {
    return state;
  }

  }

}
